export default "__VITE_PUBLIC_ASSET__36f0dafd__"